import { TFunction } from 'i18next';

export const getViewLabel = (t: TFunction, entityTranslationKey: string) =>
  `${t('common:view')} ${t(entityTranslationKey).toLowerCase()}`;
